import { create } from 'zustand';

interface ISacolaAbertaStore {
    sacolaAberta: boolean;
    abrirSacola: () => void;
    fecharSacola: () => void;
}

export const useSacolaAbertaStore = create<ISacolaAbertaStore>()((set) => ({
    sacolaAberta: false,
    abrirSacola: () => set({ sacolaAberta: true }),
    fecharSacola: () => set({ sacolaAberta: false }),
}));